module.exports = __webpack_public_path__ + "img/config.dbd0353d.svg";